// extracted by mini-css-extract-plugin
export default {"codeInput":"MI-Eyx0MVkt7z0Ae3xDWX","footer":"XBY4xSV45yZOxPXBcZ9Hf"};